<template>
  <div id="app">
    <topbar :route="route" :projectName="projectName" :projectId="projectId" v-if="showHeader" />
    <router-view/>
    <projectList class="absolute" v-if="projectListVisible" :listVisible="projectListVisible" @close="handleProjectClick" :DialogTitle='projectListTitle'></projectList>
  </div>
</template>

<script>
import topbar from './components/topbar.vue'
import projectList from './views/configFile/projectList'
import Cookies from 'js-cookie'
import config from '@/common/config'
import { mapState, mapActions } from 'vuex'

export default {
  name: 'App',
  components: { topbar, projectList },
  data () {
    return {
      showHeader: false,
      route: [],
      language: Cookies.get(config.language) || 'english',
      // projectLstVisible: false,
      projectListTitle: this.$t('myProjectDialog'),
      projectName: '',
      projectId: ''
    }
  },
  computed: {
    ...mapState([
      'projectListVisible'
    ]),
    router () {
      return this.$route
    }
  },

  watch: {
    router (val) {
      this.changeRoute({
        path: val.path,
        name: val.name,
        meta: val.meta
      })
      if (val.name !== 'login' && val.name !== 'home' && val.name !== 'resetPassword' && val.name !== 'registerSuccess' && val.name !== 'resetSuccess') {
        this.showHeader = true
      } else {
        this.showHeader = false
      }
      this.projectName = val.query.projectName
      this.projectId = val.query.projectId
      // 处理面包屑
      this.route = val.matched.map(n => {
        if (n.meta.routerName) {
          return {
            name: n.meta.routerName[this.language === 'spanish' ? 'sp' : this.language === 'portuguese' ? 'po' : 'en'],
            path: n.path
          }
        } else {
          // 特殊返回首页
          return {
            name: this.$t('home'),
            path: '/configuration'
          }
        }
        // else if (n.meta.isActive) {
        //   return {
        //     name: this.$router.currentRoute.query.name,
        //     path: n.path
        //   }
        // }
      })
    }
  },
  created () {
    // 这里添加获取语言的方法
  },
  methods: {
    ...mapActions([
      'changeRoute',
      'changeProjectVisible'
    ]),
    handleProjectClick (visible) {
      this.changeProjectVisible(false)
    }
  }
}
</script>

<style lang="less">
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
.absolute {
  position: absolute;
}
@font-face {
  font-family: baseFont;
  // src: url('./font/impact.ttf');
  // src: url(../../../src/common/style/font/impact.ttf);
  src: url(./assets/font/impact.ttf);
  font-weight: normal;
}
@font-face {
  font-family: passwordFont;
  src: url(./assets/font/password.ttf);
  font-weight: normal;
}
h1 {
  font-family: baseFont;
  font-weight: normal;
}
.password input {
  font-family: passwordFont;
  font-size: 12px;
  &::placeholder {
    font-family: system-ui;
  }
}
</style>
